import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { locationReportSelector } from './store/selector';
import {
    getLocationReportInitAction,
    getLocationReportSuccessAction,
    getLocationReportFailureAction,
    clearLocationReportAction
} from './store/reducer';
import { locationReportApiService } from './services/api';

export function useLocationReportCore() {
    const dispatch = useDispatch();
    const locationReportState = useSelector(locationReportSelector);

    const getLocationsReport = useCallback(async (companyId: number) => {
        try {
            dispatch(getLocationReportInitAction());

            const response = await locationReportApiService.getLocationsReport(companyId);
            dispatch(getLocationReportSuccessAction(response.reports));

            return response;
        } catch (error: any) {
            dispatch(getLocationReportFailureAction(error.message || 'Error al cargar el reporte de ubicaciones'));
            console.error('Error in getLocationsReport:', error);
        }
    }, [dispatch]);

    const clearLocationReport = useCallback(() => {
        dispatch(clearLocationReportAction());
    }, [dispatch]);

    return {
        // Estado
        locationsReport: locationReportState.locationsReport,
        loading: locationReportState.loading,
        error: locationReportState.error,

        // Métodos
        getLocationsReport,
        clearLocationReport,
    };
}

// Exportaciones adicionales
export * from '../../interfaces/location-report.interface'; 